import {
  Box,
  Button,
  Container,
  Heading,
  HStack,
  Icon,
  Text,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { MotionBox, TEAL, TEAL_DARK } from "./utils";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";

const CTABanner = () => (
  <Box
    as="section"
    py={{ base: 16, md: 20 }}
    px={{ base: 5, md: 8 }}
    bgGradient={`linear(155deg, ${TEAL_DARK} 0%, ${TEAL} 100%)`}
    position="relative"
    overflow="hidden"
  >
    <Box
      position="absolute"
      top="-40px"
      right="-40px"
      w="240px"
      h="240px"
      borderRadius="50%"
      bg="whiteAlpha.100"
      pointerEvents="none"
    />
    <Box
      position="absolute"
      bottom="-50px"
      left="-50px"
      w="180px"
      h="180px"
      borderRadius="50%"
      bg="whiteAlpha.50"
      pointerEvents="none"
    />

    <MotionBox
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 } as any}
    >
      <Container maxW="3xl" textAlign="center" position="relative">
        <VStack gap={5}>
          <Heading
            fontSize={{ base: "2xl", md: "3xl" }}
            color="white"
            letterSpacing="-0.03em"
          >
            Készen állsz a digitalizálásra?
          </Heading>
          <Text fontSize="lg" color="whiteAlpha.800" fontWeight={300}>
            Kezdd el percek alatt – foglalási rendszer akár weboldallal
            egyszerre, kötelezettségek nélkül.
          </Text>
          <Wrap justify="center" spacing={3} pt={2}>
            <WrapItem>
              <Button
                as="a"
                href="https://app.wobble.hu/signup_page"
                target="_blank"
                rel="noopener noreferrer"
                size="lg"
                px={8}
                py={6}
                bg="white"
                color={TEAL}
                fontWeight={700}
                borderRadius="xl"
                textDecoration="none"
                _hover={{
                  bg: "whiteAlpha.900",
                  transform: "translateY(-2px)",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                  textDecoration: "none",
                }}
                transition="all 0.22s"
                rightIcon={<FaArrowRight />}
              >
                Fiók létrehozása
              </Button>
            </WrapItem>
            <WrapItem>
              <Button
                as="a"
                href="https://book.wobble.hu"
                target="_blank"
                rel="noopener noreferrer"
                size="lg"
                px={8}
                py={6}
                bg="transparent"
                color="white"
                fontWeight={700}
                borderRadius="xl"
                border="1.5px solid whiteAlpha.500"
                textDecoration="none"
                _hover={{
                  bg: "whiteAlpha.200",
                  borderColor: "whiteAlpha.800",
                  textDecoration: "none",
                }}
                transition="all 0.22s"
              >
                Ingyenes konzultáció
              </Button>
            </WrapItem>
          </Wrap>
          <HStack gap={5} pt={2} flexWrap="wrap" justify="center">
            {[
              "Ingyenes csomag elérhető",
              "Nincs kártyaadat",
              "Bármikor lemondható",
            ].map((item, i) => (
              <HStack key={i} gap={1.5} fontSize="xs">
                <Icon color="whiteAlpha.700" as={FaCheckCircle} boxSize={3} />
                <Text color="whiteAlpha.700">{item}</Text>
              </HStack>
            ))}
          </HStack>
        </VStack>
      </Container>
    </MotionBox>
  </Box>
);

export default CTABanner;
